module.exports = __webpack_public_path__ + "static/media/04-blog.f6eafcea.png";